import React from 'react';

import { Button, Modal } from 'react-bootstrap';

import styled from 'styled-components';

const Container = styled.div`
  .modal-dialog {
    width: 90%;
  }
`;

const ContentContainer = styled.div`
   height:600px;
margin-top:0px;
overflow:scroll;
padding:30px;
  background:#fff;
  
`;

// this allows custom styling on the resume component
const Content = props =>
  <div style={{...{ width:'600px', height:'700px',padding:'40px 20px 0px 20px', background: '#585858b0'}, ...props.styles}}>
    <ContentContainer dangerouslySetInnerHTML={{ __html: props.content }}/>
  </div>

const DocumentViewerNoModal = (props) => {
  return (
    props.show
    ? <Container  >
             <Content style={{width:'100%'}} {...props}/>
      </Container>
      : <div></div>
  )
}

export default DocumentViewerNoModal;
